import Articles from '@helsenorge/core-cms/articles';
import ExpanderBlock from '@helsenorge/core-cms/behandlingsvalg/ekspanderendeblock';
import ResourceBlock from '@helsenorge/core-cms/behandlingsvalg/ressursblock';
import Breadcrumb from '@helsenorge/core-cms/breadcrumb';
import CookieBannerTrigger from '@helsenorge/core-cms/cookie-banner/cookie-banner-trigger';
import DiveBoard from '@helsenorge/core-cms/diveboard';
import FaktaBlock from '@helsenorge/core-cms/faktablock';
import FeaturedItemBlock from '@helsenorge/core-cms/featureditem';
import HeaderSkeleton from '@helsenorge/core-cms/header-skeleton';
import ImageBlock from '@helsenorge/core-cms/image';
import InfoEllerDriftsmelding from '@helsenorge/core-cms/info-eller-driftsmelding';
import LoginBlock from '@helsenorge/core-cms/loginblock';
import LoginButton from '@helsenorge/core-cms/loginblock/LoginButtonWrapper';
import PromoBoard from '@helsenorge/core-cms/promoboard';
import Promopanel from '@helsenorge/core-cms/promopanel';
import PromoSection from '@helsenorge/core-cms/promosection';
import SearchBlock from '@helsenorge/core-cms/search-v2/block';
import SearchPage from '@helsenorge/core-cms/search-v2/page';
import SearchField from '@helsenorge/core-cms/search-v2/search-field';
import SurveyInvitation from '@helsenorge/core-cms/survey-invitation';
import ToolBlock from '@helsenorge/core-cms/toolblock';
import UserFeedbackBlock from '@helsenorge/core-cms/userfeedback';
import VideoMatrise from '@helsenorge/core-cms/videomatrise';
import VideoBlock from '@helsenorge/core-cms/videospiller';

globalThis.HelsenorgeCoreCms = {
  Articles,
  Breadcrumb,
  CookieBannerTrigger,
  DiveBoard,
  ExpanderBlock,
  FaktaBlock,
  FeaturedItemBlock,
  HeaderSkeleton,
  ImageBlock,
  InfoEllerDriftsmelding,
  LoginBlock,
  LoginButton,
  PromoBoard,
  Promopanel,
  PromoSection,
  ResourceBlock,
  SearchBlock,
  SearchField,
  SearchPage,
  SurveyInvitation,
  ToolBlock,
  UserFeedbackBlock,
  VideoBlock,
  VideoMatrise,
};
